export default {
  // 付款申请单查询
  LIST_FUND_PAYMENT_APPLY_BY_PAGE: '/financial/paymentApply/listFundPaymentApplyByPage',
  // 保存
  PAYMENT_APPLY_SAVE: '/financial/paymentApply/save',
  // 删除
  PAYMENT_APPLY_DELETE: '/financial/paymentApply/delete',
  // 修改
  PAYMENT_APPLY_UPDATE: '/financial/paymentApply/update',
  // 付款申请详情
  GET_PAYMENT_APPLY_DETAIL: '/financial/paymentApply/fundPaymentApply',
  /** 行项目号-获取列表 */
  LIST_ORDER_DETAIL_BY_PAGE: '/sales/orderDetail/listOrderDetailByPage',
  /** 获取信用额度列表 */
  APPLICATION_STATISTICS_LIST_API: '/sales/creditLimitSummary/list',
  /** 获取信用额度 */
  GET_AVAILABLE_AMOUNT: '/sales/credit-service-remote/getAvailableAmount',
  // 发票列表
  INVOICE_CODES: '/financial/payment/queryFundPayableInvoice',
  // 获取供应商信息
  GET_PARTER: '/maindata/partners/getPartner',
  // 获取供应商银行信息
  GET_PARTER_BANK: '/maindata/partners/getPartnerBank',
  // 导出
  EXPORT_FUND_PAYMENT_APPLY: '/financial/paymentApply/exportPaymentApplys',
  //  提交审批
  SUBMIT2_APPROVAL: '/financial/paymentApply/submitToApproval',
  // 提交付款
  SUBMIT2_PAYMENT: '/financial/paymentApply/submitToPayment',
  // 申请关闭
  APPLY_CLOSE: '/financial/paymentApply/applyClose',
  // 付款申请单列表获取
  GET_SETTLE_LIST: '/sales/orderSettle/listOrderSettleOther',
  // 供应链主体列表
  GET_SUPPLY_LIST: 'maindata/supplier/listSuppliers',
  //生成付款单
  CREATE_PAYMENT_BY_APPLY: '/financial/paymentApply/createPayment',
  //通过发票生成付款申请
  CREATE_PAYMENTAPPLY_FOR_INVOICEID: '/financial/paymentApply/createPaymentApplyForInvoiceId',
  //批准
  PASS: '/financial/paymentApply/doAuditPassSpecially',
  //批量提交前校验
  BEFORE_BATCHSUBMIT: '/financial/paymentApply/beforeBatchSubmit',
  //提交审批
  SUBMIT: '/financial/paymentApply/batchSubmitToApproval',
  //批量提交付款
  BATCH_PAYMENT: '/financial/paymentApply/batchSubmitToPayment',
  //撤回
  WITHDRAW: '/financial/paymentApply/doWithdraw',
  // 校验是否可以生成付款单
  CHECK_FOR_CREATE_PAYMENT: '/financial/paymentApply/checkForCreatePayment',
  // 提交前校验
  BEFORE_SUBMIT: '/financial/paymentApply/beforeSubmit',
  // 付款申请导入
  IMPORT: '/financial/paymentApply/importPaymentApplys',
  // 根据付款申请号查询付款单
  QUERYPAYMENT_BY_APPLY: '/financial/fundPayment/queryPaymentDetail',
  // 更改结算批次
  UPDATE_SETTLE: '/financial/paymentApply/updateDetailForSettle',
  // 由供应商发货指令行项目提供信息
  CREATE_BY_SHIPPINGINSTRUCTION: '/financial/paymentApply/createByShippingInstruction',
  // 通过合同生成付款申请--暂时只有海宁用到
  CREATE_BY_ORDER: '/financial/paymentApply/createByOrder',
  // 预付详情里查看抵扣信息接口
  QUERY_DEDUCTION_DETAIL: '/financial/payableSettlementDeductionDetail/queryDeductionDetail',
  // 付款申请-下载导入模板
  DOWNLOAD_TEMPLATE: '/financial/paymentApply/downloadTemplate',
  // 根据付款批次和合同号获取付款批次记录及对应的发货指令信息
  GET_INSTRUCTION_DETAIL: '/warehouse/shippingInstruction/getInstructionDetail',
  // 提交前校验数据
  BEFORE_CHECK: '/financial/paymentApply/checkAppointment',
  // 列表批量提交审批前校验
  BEFOR_CHECK_LISTAPRROVE: '/financial/paymentApply/beforeBatchCheck',
  // 关联结算单时获取默认值
  QUERY_DEFALUT_VALUE: '/financial/payableSettlement/calculatedAmountById',
  // 城矿导入
  IMPORT_PAYMENTAPPLYCK: '/financial/paymentApply/importPaymentApplyForCk',
  // 城矿获取列表数据
  QUERY_LIAT_DATA: '/financial/paymentApply/pagePaymentApplyHead',
};
